<template>
	<div>
		<layout-wide>
			<sub-navbar page="Customer" />
			<div>
				<HeroBox :title="title" :subtitle="subtitle" :color="color" />
			</div>
			<div class="margin-top-20">
				<div class="container">
					<CustomersTableForSpecialPrices
						ref="customersTable"
						:company-id="companyId"
						@view-customer="handleViewCustomer"
					/>
					<!-- Add Special Price Button -->
					<div class="add-price-button-wrapper">
						<button
							class="btn-add-global-price"
							@click="openGlobalAddModal"
							type="button"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="18"
								height="18"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<line x1="12" y1="5" x2="12" y2="19"></line>
								<line x1="5" y1="12" x2="19" y2="12"></line>
							</svg>
							<span>Add Special Price</span>
						</button>
					</div>
				</div>
			</div>
		</layout-wide>

		<!-- Global Add Special Price Modal -->
		<GlobalAddSpecialPriceModal
			:visible="globalAddModalVisible"
			:company-id="companyId"
			@close="closeGlobalAddModal"
			@save-price="handleSaveGlobalPrice"
		/>
	</div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import CustomersTableForSpecialPrices from '../components/CustomersTableForSpecialPrices.vue'
import GlobalAddSpecialPriceModal from '../components/GlobalAddSpecialPriceModal.vue'
import { useAddCustomerSpecialPrice } from '../services/addCustomerSpecialPriceService'
import SubNavbar from '@/_srcv2/components/_shared/sub-navbar/SubNavbar.vue'
import HeroBox from '@/_srcv2/pages/admin/_shared/HeroBox.vue'

export default {
	name: 'GetCustomersSpecialPrices',
	components: {
		CustomersTableForSpecialPrices,
		GlobalAddSpecialPriceModal,
		SubNavbar,
		HeroBox,
	},
	setup() {
		// ? ---------------------------------------------------------------------
		const title = ref('Customer Special Price Page')
		const subtitle = ref('Add add, edit, delete customers special price')
		const color = ref('is-danger')
		// ? --------------------------------------------------------------------
		const companyId = computed(() => store.getters.getUserCurrentCompany)
		const globalAddModalVisible = ref(false)
		const customersTable = ref(null)

		const handleViewCustomer = (customer) => {
			console.log('Viewing customer:', customer)
			// Add navigation or modal logic here
		}

		const openGlobalAddModal = () => {
			globalAddModalVisible.value = true
		}

		const closeGlobalAddModal = () => {
			globalAddModalVisible.value = false
		}

		// Initialize the add customer special price service
		const {
			addPrice,
			loading: addPriceLoading,
			error: addPriceError,
		} = useAddCustomerSpecialPrice()

		const handleSaveGlobalPrice = async (priceData) => {
			try {
				const result = await addPrice({
					company_id: companyId.value,
					customer_id: priceData.customer_id,
					stock_id: priceData.stock_id,
					customers_price: priceData.customers_price,
				})

				if (result) {
					// Success - close modal and refresh table
					closeGlobalAddModal()

					// Refresh the customers table data
					if (customersTable.value && customersTable.value.refreshData) {
						await customersTable.value.refreshData()
					}

					console.log('Special price added successfully:', result)

					// You could also show a success notification here
					// store.dispatch('showNotification', { type: 'success', message: 'Special price added successfully' })
				}
			} catch (error) {
				console.error('Error adding special price:', error)
				// You could show an error notification here
				// store.dispatch('showNotification', { type: 'error', message: 'Failed to add special price' })
			}
		}

		return {
			companyId,
			handleViewCustomer,
			title,
			subtitle,
			color,
			globalAddModalVisible,
			openGlobalAddModal,
			closeGlobalAddModal,
			handleSaveGlobalPrice,
			addPriceLoading,
			addPriceError,
			customersTable,
		}
	},
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

$font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',
	Roboto, 'Helvetica Neue', Arial, sans-serif;
$font-weight-semibold: 600;

.container {
	padding: 20px;
	position: relative;
}

.add-price-button-wrapper {
	margin-top: 20px;
	padding-top: 20px;
	border-top: 1px solid #e9ecef;
	display: flex;
	justify-content: flex-start;
}

.btn-add-global-price {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 12px 24px;
	background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
	color: white;
	border: none;
	border-radius: 6px;
	font-family: $font-family-base;
	font-size: 0.9375rem;
	font-weight: $font-weight-semibold;
	cursor: pointer;
	transition: all 0.2s ease;
	box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);

	svg {
		width: 18px;
		height: 18px;
		transition: transform 0.2s ease;
	}

	&:hover {
		background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);

		svg {
			transform: rotate(90deg);
		}
	}

	&:active {
		transform: translateY(0);
		box-shadow: 0 2px 6px rgba(40, 167, 69, 0.2);
	}
}
</style>
